import axios from "axios";
import { API_URL } from "../constants/api";
import { trackAPIError } from "../utils/mixpanel";

const instance = axios.create({
  baseURL: API_URL,
});

let isRedirectingToExpired = false;

// Attach timezone to every outgoing request
instance.interceptors.request.use((config) => {
  config.headers["X-Client-Timezone"] =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
  return config;
});

// Response interceptor for API error tracking
instance.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Requests aborted by the app (e.g. a superseded price calculation) are not API errors
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    // Track API errors in Mixpanel
    const { config, response } = error;

    if (config && response) {
      trackAPIError({
        endpoint: config.url || "",
        method: (config.method || "GET").toUpperCase(),
        status_code: response.status || 0,
        error_message:
          response.data?.message || response.statusText || "Unknown error",
      });
    } else if (config) {
      // Network error (no response)
      trackAPIError({
        endpoint: config.url || "",
        method: (config.method || "GET").toUpperCase(),
        status_code: 0,
        error_message: error.message || "Network error",
      });
    }
    const isQrCodeRequest = config?.url?.includes("/qr-code");
    if (
      response?.status === 404 &&
      isQrCodeRequest &&
      !isRedirectingToExpired
    ) {
      const pathname = window.location.pathname;
      const roomUuid = pathname.split("/").filter(Boolean)[0];

      const isExcludedPage =
        pathname.includes("/qr-scan") || pathname.includes("/scan-qr-code");

      if (roomUuid && !isExcludedPage) {
        isRedirectingToExpired = true;
        window.location.replace(`/${roomUuid}/qr-scan`);
      }
    }
    // Re-throw the error so it can be handled by the calling code
    return Promise.reject(error);
  }
);

export default instance;
